import * as React                    from 'react';
import * as PropTypes                from 'prop-types';
import * as cx                       from 'classnames';
import icons                         from '../../icons';
import { MessagesInputType }         from './MessagesInputTypes';
import { ViewContextType }           from '../MessageTemplatesList/MessageTemplatesListTypes';
import { MessageDeliveryStatusType, MessageDeliveryStatuses } from '../../types';

interface DefaultInputProps {
    handleChange: (event: React.SyntheticEvent<MessagesInputType>) => void;
    handleKeyDown: () => void;
    waitingForReplyStatus: boolean;
    value: string;
    characterLimit: number;
    handleSendMessage: () => void;
    inputView: ViewContextType;
    lastMessageStatus: MessageDeliveryStatusType;
}

const DefaultInput: React.StatelessComponent<DefaultInputProps> = ({ handleChange, handleKeyDown, waitingForReplyStatus, value, characterLimit, handleSendMessage, lastMessageStatus }, { translate }) => {
    const placeholder = waitingForReplyStatus ? translate('waiting_for_reply') : translate('reply');
    const validMessage = value.length > 0 && value.length <= characterLimit;
    const reachedCharacterLimit = characterLimit - value.length < 0;

    return (
        <div className="messagesInput">
            <textarea
                id="message_feed_input"
                className="messagesInput__input"
                placeholder={placeholder}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                disabled={waitingForReplyStatus || lastMessageStatus === MessageDeliveryStatuses.ERROR}
                value={value}
            />
            <div className={cx('messagesInput__characterCount', { is_negative: reachedCharacterLimit })}>
                {value.length} / {characterLimit}
            </div>
            <div
                className={cx(
                    'footer__send',
                    { 'footer__send-active': validMessage && !reachedCharacterLimit },
                    { 'footer__send-error': !validMessage && reachedCharacterLimit }
                )}
                title={validMessage && !reachedCharacterLimit ? translate('send_message') : ''}
                onClick={validMessage && !reachedCharacterLimit ? handleSendMessage : null}
            >
                {!reachedCharacterLimit ? icons.upArrow : icons.exclaimationMark}
            </div>
        </div>
    );
};

export default DefaultInput;

DefaultInput.contextTypes = {
    translate: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/sections/MessagesInput/DefaultInput.tsx